import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'

export default css`
  .show-more-container {
    margin: 1rem 0;
    text-align: center;
  }
`